import { render } from "./JournalList.vue?vue&type=template&id=486349e4&scoped=true&ts=true"
import script from "./JournalList.vue?vue&type=script&lang=ts"
export * from "./JournalList.vue?vue&type=script&lang=ts"

import "./JournalList.vue?vue&type=style&index=0&id=486349e4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-486349e4"]])

export default __exports__